import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import home1 from "../../../assets/img/banner/slider-1.png";
import home2 from "../../../assets/img/banner/slider-2.png";
import home3 from "../../../assets/img/banner/slider-3.png";

import logo from "../../../assets/img/logo.png";

import "./Banner.css";
import { Link } from "react-router-dom";
import { useGetBannerQuery } from "./bannerSlice";
import axios from "axios";
import { bannerDB } from "../../../rki-data/banner";
import { isMobile } from "react-device-detect";
import { base_url } from "../../../server";
const bannerData = bannerDB;
function Banner() {
  const [data, setData] = useState();
  const baseUrl = base_url();

  var settings = {
    dots: false,
    infinite: true,
    speed: 600,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}banner/public`, {
        withCredentials: true,
      });
      setData(res.data);
    } catch (error) {
      console.log("Server Error BannerList");
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* <section className="bannerSection">
        <Slider {...settings}>
          {data &&
            data.slice(0, 2).map((item) => {
              return (
                item?.image?.url && (
                  <Link to={item?.url || ""} key={item._id}>
                    <div className="bannerItem">
                      <img src={item?.image.url} className="img-fluid" />
                      <div className="bannerText">
                        <h2>
A Leading Global Engineering and Construction Company, Listed in india with a diversified  portfolio of projects worldwide</h2>
                      </div>
                    </div>
                  </Link>
                )
              );
            })}
        </Slider>
      </section> */}

      <section className="bannerSection">
        <Slider {...settings}>
          <div>
            <div
              className="bannerItem"
              style={{
                backgroundImage: `url(${home1})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "right",
              }}
            >
              <Link to={"/"}>
                <div className="bannerText">
                  <h2>
                    <span>Maintenance Tooling </span> &amp; Equipments
                  </h2>
                  <p>
                    We are the market leader in the airline industry with
                    innovation, experience and reliability. We have been able to
                    provide comprehensive solutions to every part of the
                    aviation industry with innovative technologies, Knowledge
                    based approach and our dedication to quality and safety.
                  </p>
                </div>
              </Link>
            </div>
          </div>
          <div>
            <div
              className="bannerItem"
              style={{
                backgroundImage: `url(${home2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "bottom",
              }}
            >
              <Link to={"/"}>
                <div className="bannerText">
                  <h2>
                    <span>End to end</span> service
                  </h2>
                  <p>
                    We strive to produce innovative solutions, from design,
                    manufacture, procurement, supply and installation to
                    logistics, testing and commissioning. GGAS is the single
                    stop for your turnkey aviation services.
                  </p>
                </div>
              </Link>
            </div>
          </div>
          <div>
            <div
              className="bannerItem"
              style={{
                backgroundImage: `url(${home3})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <Link to={"/"}>
                <div className="bannerText">
                  <h2>
                    <span>Innovative</span> solutions
                  </h2>
                  <p>
                    We are the market leader in the airline industry with
                    innovation, experience and reliability. We have been able to
                    provide comprehensive solutions to every part of the
                    aviation industry with innovative technologies, Knowledge
                    based approach and our dedication to quality and safety.
                  </p>
                </div>
              </Link>{" "}
            </div>
          </div>
        </Slider>
      </section>
    </>
  );
}

export default Banner;
